import React from "react";
import {
  Tabbar,
  Tab,
  Page,
  Splitter,
  SplitterContent,
  SplitterSide
} from "react-onsenui";
import AnalyzePage from "./pages/AnalyzePage";
import HelpPage from "./pages/HelpPage";
import SubstancesIndexPage from "./pages/SubstancesIndexPage";
import SubstancePage from "./pages/SubstancePage";
import HamburgerMenu from "./components/HamburgerMenu";
import { getSubstance, getSubstanceByToken } from "./services/megamix";
import { getSubstanceIdFromUrl, substanceToPathname } from "./services/url";

class TabPage extends React.Component {
  render() {
    return <Page>{React.createElement(this.props.component, this.props)}</Page>;
  }
}

const tabs = [
  //{ title: "Home", testid: "homeTab", component: HomePage, icon: "home" },
  {
    title: "Results",
    testid: "analyzeTab",
    component: AnalyzePage,
    icon: "flask"
  },
  {
    title: "Substances",
    testid: "substancesTab",
    component: SubstancesIndexPage,
    icon: "pills"
  },
  {
    title: "Help",
    testid: "helpTab",
    component: HelpPage,
    icon: "exclamation-triangle"
  }
];

const tabRoutes = {
  0: "/analyze",
  1: "/substances",
  2: "/help"
};

const tabIndexFromPath = (path) => {
  for (const routeIndex in tabRoutes) {
    const routePath = tabRoutes[routeIndex];
    if (path.startsWith(routePath)) {
      return parseInt(routeIndex, 10);
    }
  }
  return 0;
};

const pathFromTabIndex = (index) => {
  if (index == 0) {
    if (document.analyzeQueryUrl) {
      return document.analyzeQueryUrl;
    } else {
      return tabRoutes[index];
    }
  }
  else if (tabRoutes[index] != null) {
    return tabRoutes[index];
  }
  return '/';
};

export default class MobileAppNavigation extends React.Component {
  state = {
    isMenuOpen: false,
    initialTabIndex: 0
  };

  // Read main tab from URL
  UNSAFE_componentWillMount() {
    const path = window.location.pathname;
    const initialTabIndex = tabIndexFromPath(path);
    this.setState({ initialTabIndex });
  }

  // Read open page from url
  componentDidMount() {
    let substanceId = getSubstanceIdFromUrl(window);

    if (substanceId == null) {
      return;
    }

    // Navigate to substance
    console.log("AppNavigation: navigating to substance " + substanceId);

    let substance;
    const substanceById = getSubstance(substanceId);
    if (substanceById == null) {
      const substanceByToken = getSubstanceByToken(substanceId);
      if (substanceByToken == null) {
        console.log("AppNavigation: failed to find substance by id or token", substanceId);
        return;
      } else {
        substance = substanceByToken;
      }
    } else {
      substance = substanceById;
    }

    const newPathname = substanceToPathname(window, substance);

    console.log(`AppNavigation: scheduling navigation to ${newPathname}`);
    setTimeout(() => {
      console.log(`AppNavigation: executing navigation to ${newPathname}`);
      this.props.navigator.pushPage({
        component: SubstancePage,
        props: {
          key: "substance-" + substance.id,
          substance: substance
        }
      });
      window.history.replaceState(
        { substance: substance.id },
        '',
        newPathname
      );
    }, 1);
  }

  updateUrl(index) {
    const path = pathFromTabIndex(index);
    window.history.replaceState(
      { tab: index }, '', path
    );
  }

  showMenu() {
    this.setState({ isMenuOpen: true });
  }

  hideMenu() {
    this.setState({ isMenuOpen: false });
  }

  renderTabs() {
    return tabs.map(tab => {
      return {
        content: (
          <TabPage
            key={tab.title}
            title={tab.title}
            navigator={this.props.navigator}
            component={tab.component}
            showMenu={this.showMenu.bind(this)}
          />
        ),
        tab: (
          <Tab
            key={tab.title}
            label={tab.title}
            icon={tab.icon}
            data-testid={tab.testid}
            className="clickable"
          />
        )
      };
    });
  }

  render() {
    return (
      <Page>
        <Splitter>
          <SplitterContent>
            <Tabbar
              id="bottom-tabbar-container"
              renderTabs={this.renderTabs.bind(this)}
              onPreChange={({ index }) => this.updateUrl(index)}
              index={this.state.initialTabIndex}
            />
          </SplitterContent>

          <SplitterSide
            side="right"
            width={300}
            collapse={true}
            isOpen={this.state.isMenuOpen}
            onOpen={this.showMenu.bind(this)}
            onClose={this.hideMenu.bind(this)}
            swipeable
          >
            <HamburgerMenu
              isMenuOpen={this.state.isMenuOpen}
              hideMenu={this.hideMenu.bind(this)}
              showMenu={this.showMenu.bind(this)}
              navigator={this.props.navigator}
            />
          </SplitterSide>
        </Splitter>
      </Page>
    );
  }
}
